import { Store } from 'types/store';
import React from 'react';
import { useSelector } from 'react-redux';
import useViewport from 'utils/useViewportHelper';

type StepperProps = {
  step: 1 | 2 | 3 | 4;
};

// eslint-disable-next-line import/no-dynamic-require, global-require, @typescript-eslint/no-var-requires
const fetchUrl = (step: number, device: string, useDefault: boolean): string => require(`assets/images/renewal/${device}/${useDefault ? 'default/' : ''}stepper-${step}.png`);

const Stepper: React.FC<StepperProps> = ({ step }) => {
  const useDefault = useSelector((state: Store) => state.expiryRenewal.useDefaultStepper as boolean);
  const { isMobile } = useViewport();
  const device = isMobile ? 'mobile' : 'desktop';

  switch (step) {
    case 1:
      return <img src={fetchUrl(1, device, useDefault)} alt="Step 1 of Renewal: Your cover" width="100%" className="py-2" />;
    case 2:
      if (useDefault) return null;
      return <img src={fetchUrl(2, device, false)} alt="Step 2 of Renewal: Customise" width="100%" className="py-2" />;
    case 3:
      return <img src={fetchUrl(3, device, useDefault)} alt="Step 3 of Renewal: Summary" width="100%" className="py-2" />;
    case 4:
      return <img src={fetchUrl(4, device, useDefault)} alt="Step 4 of Renewal: Payment" width="100%" className="py-2" />;
    default:
      return null;
  }
};

export default Stepper;
